import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '../components/ThemeContext';
import { FileText, TrendingUp, Newspaper, DollarSign, BookOpen, Settings } from 'lucide-react';

interface SitemapProps {
  openPopup?: () => void;
}

const Sitemap: React.FC<SitemapProps> = ({ openPopup }) => {
  const { theme } = useTheme();
  const navigate = useNavigate();
  console.log('Sitemap render',openPopup);

  const sitemapSections = [
    {
      title: 'Main Pages',
      icon: FileText,
      links: [
        { path: '/', label: 'Home', isAuth: false },
        { path: '/about', label: 'About Us', isAuth: false },
        { path: '/about', label: 'Contact', isAuth: false },
        { path: '/pricing', label: 'Pricing', isAuth: false },
      ]
    },
    {
      title: 'Markets',
      icon: TrendingUp,
      links: [
        { path: '/fund-insights', label: 'Fund Insights', isAuth: false },
        { path: '/market-movers', label: 'Market Movers', isAuth: false },
        { path: '/chart-analysis', label: 'Chart Analysis', isAuth: false },
        { path: '/screener', label: 'Screener', isAuth: false },
        { path: '/compare', label: 'Compare Stocks', isAuth: false },
        { path: '/news', label: 'News', isAuth: false },
      ]
    },
    {
      title: 'Account',
      icon: Settings,
      links: [
        { path: '/login', label: 'Login', isAuth: true },
        { path: '/register', label: 'Sign Up', isAuth: true },
        { path: '/profile', label: 'Profile', isAuth: false },
        { path: '/pricing', label: 'Stock Forecast', isAuth: false },
        { path: '/pricing', label: 'SWOT Analysis', isAuth: false },
      ]
    },
    {
      title: 'Legal',
      icon: DollarSign,
      links: [
        { path: '/terms-of-service', label: 'Terms of Use', isAuth: false },
        { path: '/privacy-policy', label: 'Privacy Policy', isAuth: false },
        { path: '/disclaimer', label: 'Data Disclaimer', isAuth: false },
      ]
    },
  ];

  return (
    <div className={`min-h-screen ${theme === 'dark' ? 'bg-theme-primary' : 'bg-white'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <h1 className={`text-4xl font-bold mb-4 ${theme === 'dark' ? 'text-theme-primary' : 'text-gray-900'}`}>
            Sitemap
          </h1>
          <p className={`text-lg ${theme === 'dark' ? 'text-theme-muted' : 'text-gray-600'}`}>
            Navigate through all pages and sections of Stock Fortress
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {sitemapSections.map((section, idx) => {
            const Icon = section.icon;
            return (
              <div
                key={idx}
                className={`p-6 rounded-lg border ${
                  theme === 'dark' ? 'bg-theme-secondary border-theme-tertiary' : 'bg-gray-50 border-gray-200'
                }`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <Icon className={`w-6 h-6 ${theme === 'dark' ? 'text-blue-400' : 'text-blue-600'}`} />
                  <h2 className={`text-xl font-semibold ${theme === 'dark' ? 'text-theme-primary' : 'text-gray-900'}`}>
                    {section.title}
                  </h2>
                </div>
                <ul className="space-y-2">
                  {section.links.map((link, linkIdx) => (
                    <li key={linkIdx}>
                      {link.isAuth ? (
                        <Link
                          to={link.path}
                          onClick={(e) => {
                            e.preventDefault();
                            if (openPopup) {
                              openPopup();
                            } else {
                              navigate(link.path);
                            }
                          }}
                          className={`hover:underline cursor-pointer ${
                            theme === 'dark' ? 'text-theme-secondary hover:text-theme-primary' : 'text-gray-600 hover:text-gray-900'
                          }`}
                        >
                          {link.label}
                        </Link>
                      ) : (
                        <Link
                          to={link.path}
                          className={`hover:underline ${
                            theme === 'dark' ? 'text-theme-secondary hover:text-theme-primary' : 'text-gray-600 hover:text-gray-900'
                          }`}
                        >
                          {link.label}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Sitemap;
